'use client';

import clientFetcher from '@lib/client-fetcher';
import { TeacherProfile, UserStatus } from 'types/collections';

/**
 * Service for retrieving teacher data
 */
export class TeacherService {
  async getTeacherProfile(): Promise<TeacherProfile> {
    return await clientFetcher({
      url: '/api/teacher/profile',
    });
  }

  /**
   * Update teacher profile information
   */
  async updateTeacherProfile(profile: {}): Promise<TeacherProfile> {
    return await clientFetcher({
      url: '/api/teacher/profile',
      method: 'PATCH',
      body: profile,
    });
  }

  /**
   * Request to delete teacher profile
   */
  async requestAccountDeletion(): Promise<void> {
    return await clientFetcher({
      url: '/api/teacher/profile-deletion',
      method: 'POST',
    });
  }
  // Admin functions using API routes

  /**
   * Get all teachers for admin management view
   */

  async getAllTeachersForAdmin(): Promise<TeacherProfile[]> {
    return clientFetcher<TeacherProfile[]>({ url: '/api/admin/teachers' });
  }

  /**
   * Get single techer by ID for admin view with full details
   */
  async getTeacherByIdForAdmin(userId: string): Promise<TeacherProfile> {
    return clientFetcher<TeacherProfile>({ url: `/api/admin/teachers/${userId}` });
  }

  /**
   * Updates only the status field of a teacher's profile
   * @param userId - The unique identifier of the teacher
   * @param updates - Contains the new status to be applied
   */

  async updateTeacherForAdmin(userId: string, updates: { status: UserStatus }): Promise<void> {
    await clientFetcher<{ success: boolean; message: string; data: TeacherProfile }>({
      url: `/api/admin/teachers/${userId}`,
      method: 'PATCH',
      body: updates,
    });
  }
}
